import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {validationsList_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";
import {UploadStatusHandler} from "../utils/UploadStatusHandler";
import {tagTypesEdit_template} from "../components/templates/tagTypesEdit_template";


declare var ko: any;
declare var page: any;

export class tagTypes_edit extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected imageXHRHdl: XMLHttpRequestHandler;
    protected editForm: tagTypesEdit_template;
    protected validationsList: validationsList_template;
    public uploadStatus: UploadStatusHandler = new UploadStatusHandler();
    protected progressBar: HTMLProgressElement;
    protected uploadProgress: any;
    protected XHRHdlCaller: string;

    protected getModuleName() {
        return "tagTypes_edit";
    }

    buildContent(): Array<Element> {

        // create the users list
        this.editForm = new tagTypesEdit_template("editForm", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Tag Type Form");

        if (this.isBrand()) {
            this.editForm.setBrandId(this.getBrandId());
        } else {

            this.editForm.setBrandId(undefined);
        }

        return [this.editForm.build()];
    }

    fillPage(): void {


        this.getDatasetOptions();
        this.getBrandOptions();
        this.getProductSchemaTemplateOptions();
        this.editForm.buildDatePickerCalendar();
        this.getFormData();
    }

    protected cancel() {

        this.releaseLock('cancel');
    }

    private buildReleaseTagTypeLockUrl() {
        let idTagType = this.getVnAppZone().getApp().params.idTagType;

        let endpoint: string = '/api/tag/types/release/' + idTagType;
        if (this.isBrand()) {
            let brandId = this.getBrandId();
            endpoint = "/api/brand/" + brandId + "/tag/types/release/" + idTagType;
        }

        return endpoint;
    }


    protected releaseLock(actionSource: string) {

        // request a lock release
        let usrReq_url = this.buildReleaseTagTypeLockUrl();

        this.XHRHdlCaller = actionSource;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onPostRequestReleaseLockReturn;
        this.XHRHdl.execute();
    }

    protected onPostRequestReleaseLockReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let redirectionUrl = obj.getVnAppZone().app.getLastRoute();
                if (obj.XHRHdlCaller === 'save') {
                    redirectionUrl = obj.buildListRequestUrl();
                }

                page.redirect(redirectionUrl);
            });
        }
    }

    protected getFormData() {

        this.loadingIn(this.editForm.builtTemplate);

        let idTagType = this.getVnAppZone().getApp().params.idTagType;

        let usrReq_url: string = this.buildGetOneRequestUrl(idTagType);

        let usrReq_params: Array<Array<string>> = [];

        let vm:any = this.editForm.getViewModelForRequest();
        usrReq_params.push(["data", ko.toJSON(vm)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.tagType) {
                    obj.setTagType(responseParsed.data);
                }
                obj.editForm.setGroupings(responseParsed.data.groupings);
                obj.editForm.setPermissions(responseParsed.data.permissions);
            });

            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }

    public setTagType(data): void {

        this.editForm.setId(data.tagType.id);
        this.editForm.setName(data.tagType.name);
        this.editForm.setSpecifications(data.tagType.fields);
        this.editForm.setDatasetId(data.tagType.dataset ? data.tagType.dataset.id : null);
        this.editForm.setBrandOwner(data.tagType.brandOwner ? data.tagType.brandOwner : null);

        if (typeof data.tagType.productSchemaTemplate !== 'undefined' && data.tagType.productSchemaTemplate !== null) {
            this.editForm.setProductSchemaTemplateId(data.tagType.productSchemaTemplate.id);
        }
    }

    protected saveTagType() {

        // LOADING : starts
        this.loadingIn(this.editForm.builtTemplate);

        this.XHRHdlCaller = 'save';
        let formReq_url: string = this.buildSaveRequestUrl()

        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.editForm.getViewModelForRequest()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = this.onPostFormReturn;
        XHRHdl.execute();
    }

    // use the form data to fill the form
    protected onPostFormReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Tag saved successfully !");
                obj.releaseLock('save');
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }

    protected getTagByType(idType, keyword) {

        let usrReq_url: string = '/api/tags/get_by_type/' + idType;
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            usrReq_url = '/api/brand/' + idBrand + '/tags/get_by_type/' + idType;
        }
        let subViewModel = {keyword: keyword, idTagType: idType}
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetTagRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);
                let tags = responseParsed.data;
                if(tags){
                    obj.editForm.setTagFilter(tags);
                }
            });
        }
    }

    protected validateTagSpec(idField, idType, label, dataType, restrictionTypes, oldRestrictionTypeArray, addedSpecNames) {

        // LOADING : starts
        this.loadingIn(this.editForm.builtTemplate);

        let formReq_url: string = '/api/tag/types/field/validate/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = {idType: idType, label: label, idField: idField, dataType: dataType,restrictionTypes: restrictionTypes,oldRestrictionTypeArray: oldRestrictionTypeArray, addedSpecs: addedSpecNames};
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);
                    if (responseParsed.data.valid) {
                        obj.editForm.addSpecification();
                        obj.editForm.getTemplateViewModel().restrictionTypeArray([]);
                    }
                });
                obj.loadingOut(obj.editForm.builtTemplate);

            }
        });
        XHRHdl.execute();
    }

    //image picker functions
    protected getImageData() {

        if (this.imageXHRHdl) {
            this.imageXHRHdl.cancelAndReset();
        }

        this.editForm.imagePicker.showLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/images/get/';
        let formReq_params: Array<Array<string>> = [];

        //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));

        formReq_params.push(["data", ko.toJSON(this.editForm.imagePicker.getViewModelForRequest())]);

        this.imageXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.imageXHRHdl.execute();
    }

    protected onGetImageDataReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                obj.editForm.imagePicker.hideLoading();
                if (obj.editForm.imagePicker.getSelectedTab() == 'images' || obj.isSaveImage) {
                    obj.isSaveImage = false;
                }
                //TODO after save
            })
        }
    }

    protected updateImagePickerForm(responseParsed) {
        let selectedImages = this.editForm.imagePicker.getSelectedImages();

        if (responseParsed.paginatedImages && responseParsed.paginatedImages.data) {
            for (let image of responseParsed.paginatedImages.data) {
                image.selected = false;
                let imageSelected = selectedImages.find(i => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.editForm.imagePicker.setImagesPagination(responseParsed.paginatedImages);
            this.editForm.imagePicker.setImageResults(responseParsed.paginatedImages.data);
        }
    }

    protected bytesToSize(bytes) {
        var sizes = ['KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return 'n/a';
        var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        if (i == 0) return bytes + ' ' + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
    }

    protected insertImage(image, target) {

        let imgTag = this.buildImageTag(image, false);

        if (target == "tagImage") {
            this.editForm.setTagImage(image);
        }

    }

    protected buildImageTag(image, addCaption): string {
        let imgTag = '<img ';
        imgTag += 'src="' + image.url + '" ';
        if (image.altText != null) {
            imgTag += 'alt="' + image.altText + '" ';
        } else {
            imgTag += 'alt="" ';
        }
        imgTag += ' width=' + image.width + ' height=' + image.height + ' />';

        //add caption
        if (addCaption && image.caption != null && image.caption.trim() != "") {
            imgTag = '[caption]' + imgTag + ' ' + image.caption + '[/caption]';
        }

        return imgTag;
    }

    public getProductSchemaTemplateOptions() {

        // LOADING : starts
        this.loadingIn(this.editForm.builtTemplate);

        let usrReq_url: string = '/api/search/tag/schema_templates/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetProductSchemaTemplateOptionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetProductSchemaTemplateOptionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.templateTypes) {

                    let templateOptions = response.data.templateTypes;
                    obj.editForm.setProductSchemaTemplateOptions(templateOptions);
                }

            });
        }
    }

    public getDatasetOptions() {

        // LOADING : starts
        this.loadingIn(this.editForm.builtTemplate);

        let usrReq_url: string = '/api/search/tag/dataset/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onDatasetOptionsReturn;
        this.XHRHdl.execute();
    }

    protected onDatasetOptionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.templateTypes) {

                    let templateOptions = response.data.templateTypes;
                    obj.editForm.setDatasetOptions(templateOptions);
                }

            });
        }
    }

    public getBrandOptions() {

        // LOADING : starts
        this.loadingIn(this.editForm.builtTemplate);

        let usrReq_url: string = '/api/brands/get';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onBrandOptionsReturn;
        this.XHRHdl.execute();
    }

    protected onBrandOptionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let brands = JSON.parse(req.request.response);

                if (brands) {
                    brands.sort((a,b) => a.name < b.name? -1 : 1)
                    obj.editForm.setBrandOptions(brands);
                }
            });
        }
    }

    public getTagTypesSuggestion(keyword, idElement) {

        this.XHRHdl.cancelAndReset();

        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/search/tag/type/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagTypesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {


                let response = JSON.parse(req.request.response);

                if (response.data.tagTypes) {

                    response.data.tagTypes.forEach(tagType => {
                        tagType.name += ` ${tagType.formattedDataset}`;
                    })
                    // obj.editForm.setTagTypeFilter(response.data.idElement, response.data.tagTypes);
                    obj.editForm.restrictionFilter.setOptions(response.data.tagTypes);
                }

            });
        }
    }

    public filterSimpleOnChange(idElement): void {

        if (idElement == 'tagFilter') {

            this.editForm.addTag();
        }

        if (idElement == 'tagTypeFilter') {

            this.editForm.addTagType();
        }

        else {
            this.getImageData();
        }

    }

    public getTagsSuggestion(keyword, idElement) {

        this.XHRHdl.cancelAndReset();

        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.tags) {

                    obj.editForm.setTagFilter(response.data.tags);
                }

            });
        }
    }

    protected handleFiles(files) {

        this.uploadImages(files);

    }

    protected saveImages(images, insert) {

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/images/save/';
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(images)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let response = JSON.parse(req.request.response);

                    obj.editForm.imagePicker.onImageSaveReturn(response.images, insert);

                    obj.getImageData();
                })

            }
        });
        XHRHdl.execute();
    }

    protected filterSimpleCancel() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }

    // @TODO - refactor this
    protected uploadImages(files) {


        console.log('trial  - ' + this.uploadStatus.currentTrial);

        let parent = this;
        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/images/upload/';

        var formData = new FormData();

        this.initializeProgress(files.length);

        if (files.length > 1) {

            this.editForm.imagePicker.hideImageAdd();
            this.editForm.imagePicker.showLoading();
        }

        this.editForm.imagePicker.clearFilters();

        // upload status vars.
        this.uploadStatus.nextTrial();

        for (let i = 0; i < files.length; i++) {

            formData.append("file_" + i, files[i]);

        }
        formData.append("idBrand", idBrand);

        let request = [];
        var xhttp = new XMLHttpRequest();
        request["request"] = xhttp;

        // Set POST method and ajax file path
        xhttp.open("POST", formReq_url, true);

        let onReadyStateFunction = (function (req, obj) {

            return function () {

                if (req.request.readyState == 4) {

                    if (req.request.status == 200) {

                        // reset the upload status when successful operation is complete.
                        obj.uploadStatus.reset();
                        let fileElement: any = document.getElementById("fileElem");
                        fileElement.value = '';
                        let response = JSON.parse(req.request.response);

                        obj.updateProgress(response.images.length, 100) // <- Add this

                        if (response.images.length == 1) {

                            obj.editForm.imagePicker.editImage(response.images[0]);
                            obj.editForm.imagePicker.hideLoading();
                        }

                        if (response.images.length > 1) {

                            obj.saveImages(response.images, false);
                        }
                        obj.resetProgress();
                        obj.validationTemplate.clearMessages();
                    } else {
                        obj.uploadStatus.isInProgress = false;
                        obj.editForm.imagePicker.showUploadError();
                    }
                }

            }
        });

        // call on request changes state
        xhttp.onreadystatechange = onReadyStateFunction(request, this);

        let firstTime = new Date().getTime();
        xhttp.upload.addEventListener("progress", function (e) {

            parent.uploadStatus.progress = e.loaded;
            let progressTime = new Date().getTime();
            let diff =  progressTime - firstTime;
            firstTime = progressTime;
            console.log('Upload Image progress: ', e.loaded, e.total, parent.uploadStatus.progress, diff);
        });

        xhttp.upload.addEventListener('loadend', (e) => {

            if (!parent.uploadStatus.isInProgress && parent.uploadStatus.trialsReached()) {
                xhttp.abort();
                parent.editForm.imagePicker.showPickerUploadError();
                parent.editForm.imagePicker.hideLoading();
            }
            console.log('Upload Image Loadend: ', parent.uploadStatus.progress, e.loaded, e.total);
        });

        xhttp.upload.addEventListener('loadstart', (e) => {

            console.log('timeout started');
            setTimeout(() => {

                // check after one second if the progress is blocked then trigger another try.
                if (!parent.uploadStatus.isInProgress && !parent.uploadStatus.trialsReached()) {
                    xhttp.abort();
                    parent.uploadImages(files);
                }
            }, 1000);

        });

        // Send request with data
        xhttp.send(formData);
    }

    public reset(){
        this.uploadStatus.reset();
        this.editForm.imagePicker.hidePickerUploadError();
    }

    protected initializeProgress(numFiles) {
        this.progressBar = <HTMLProgressElement>document.getElementById('progress-bar');
        this.progressBar.value = 0
        this.uploadProgress = [];

        for (let i = numFiles; i > 0; i--) {
            this.uploadProgress.push(0)
        }
    }

    protected resetProgress() {
        this.progressBar = <HTMLProgressElement>document.getElementById('progress-bar');
        this.progressBar.value = 0
    }

    protected updateProgress(fileNumber, percent): void {

        this.progressBar.value = percent;
    }


    protected buildGetOneRequestUrl(id: number): string {

        let url: string = '/api/tag/types/get/' + id;

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            url = '/api/brand/' + brandId + '/tag/types/get/' + id;
        }
        return url;
    }

    protected buildListRequestUrl(): string {

        let url = '/categorization/tag-types'

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            url = '/brand/'+ brandId +'/categorization/tag-types'
        }
        return url;
    }

    protected buildResetRequestUrl(): string {

        let url = '/categorization/tag-types/edit/'

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            url = '/brand/'+ brandId +'/categorization/tag-types/edit/'
        }

        return url + this.editForm.getDatasetID();
    }


    protected buildSaveRequestUrl(): string {

        let url: string = '/api/tag/types/save/';

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            url = '/api/brand/'+ brandId +'/tag/types/save/'
        }
        return url;
    }

    public isBrand(): boolean {

        let number = Number(this.getBrandId());
        return Number.isInteger(number);
    }

    public getBrandId(): number {

        return Number(this.getVnAppZone().app.params.idBrand);
    }

    protected onAutocompleteInputClick(idElement) {

        if ( idElement == "filterAutocompleteTagType_template" )
        {

            let filterTypes = this.editForm.restrictionFilter.getTemplateViewModel();

            if (filterTypes.addNewSelected())
            {
                this.editForm.restrictionFilter.setOptions([]);

            }
        }
    }

    protected getSuggestions(keyword, idSourceElement) {
        if (idSourceElement == "filterAutocompleteTagType_template") {

            let filterTypes = this.editForm.restrictionFilter.getTemplateViewModel();
            this.getTagTypesSuggestion(filterTypes.inputText(), 5);

        }
    }

    protected onAutocompleteOptionChange(idElement) {

        if (idElement == "filterAutocompleteTagType_template") {
            let restrictionType = this.editForm.restrictionFilter.getTemplateViewModel().optionObj();
            if (restrictionType) {
                let restrictionTypeArray = this.editForm.getTemplateViewModel().restrictionTypeArray();
                let currentRestrictions = this.editForm.getTemplateViewModel().restrictionTypeArray().concat(this.editForm.getTemplateViewModel().oldRestrictionTypeArray());
                let addRestriction = true;
                for(let i =0; i<currentRestrictions.length; i++){
                    if(currentRestrictions[i].id == restrictionType.id){
                        addRestriction = false;
                        break;
                    }
                }
                if(addRestriction){
                    restrictionTypeArray.push(restrictionType);
                    this.editForm.getTemplateViewModel().restrictionTypeArray(restrictionTypeArray);
                }
                this.editForm.restrictionFilter.clearSelectedOption();
            }
        }
    }

    protected onAutocompleteInputClear(idElement){

    }

    protected getTagTypes(listTagTypesId, handler) {

        if(listTagTypesId && listTagTypesId.length>0){

            if (this.XHRHdls[handler]) {

                this.XHRHdls[handler].cancelAndReset();
            }

            let usrReq_url: string = '/api/tag/types/get/';
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON({filters      : {
                    ids : listTagTypesId
                }})]);
            this.XHRHdls[handler] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            if(handler == 'getOldTagTypes'){
                this.XHRHdls[handler].onReadyStateFunction = this.onGetOldTagTypesReturn;
            }else{
                this.XHRHdls[handler].onReadyStateFunction = this.onGetTagTypesReturn;
            }
            this.XHRHdls[handler].execute();
        }
    }

    protected onGetTagTypesReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);
                if (response.data) {
                    response.data.forEach(tagType => {
                        tagType.name += ` ${tagType.formattedDataset}`;
                    })
                    obj.editForm.getTemplateViewModel().restrictionTypeArray(response.data);
                }
            });
        }
    }

    protected onGetOldTagTypesReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);
                if (response.data) {

                    obj.editForm.getTemplateViewModel().oldRestrictionTypeArray(response.data);
                }
            });
        }
    }

    public removeErrorMessagePanel(): void {

        this.validationTemplate.clearMessages();
    }
}



// WEBPACK FOOTER //
// ./js/modules/tagTypes_edit.ts